import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact from '../hooks/__generated__/useDefaultAndSpaceClassificationLevelsQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadDefaultAndSpaceClassificationLevels(spaceKey: string = ''): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query({
		query: UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact,
		variables: {
			spaceKey,
		},
	});
}
